/**
 * SERVICE AREA — ZIPs por condado (Pinellas / Hillsborough / Pasco).
 * Un zip fuera de esta lista = fuera de área = descalifica (ver payload contract).
 * Lista de ARRANQUE razonablemente completa; calibrable. Un solo source of truth
 * para el front (gate del estimador) y el back (validación del webhook la re-usa).
 */
export const SERVICE_AREA_ZIPS: Record<"Pinellas" | "Hillsborough" | "Pasco", string[]> = {
  Pinellas: [
    "33701", "33702", "33703", "33704", "33705", "33706", "33707", "33708", "33709",
    "33710", "33711", "33712", "33713", "33714", "33715", "33716", "33755", "33756",
    "33759", "33760", "33761", "33762", "33763", "33764", "33765", "33767", "33770",
    "33771", "33772", "33773", "33774", "33776", "33777", "33778", "33781", "33782",
    "33785", "33786", "34677", "34681", "34683", "34684", "34685", "34688", "34689",
    "34695", "34698", "34660",
  ],
  Hillsborough: [
    "33510", "33511", "33534", "33547", "33548", "33549", "33556", "33558", "33559",
    "33563", "33565", "33566", "33567", "33569", "33570", "33572", "33573", "33578",
    "33579", "33584", "33592", "33594", "33596", "33598", "33602", "33603", "33604",
    "33605", "33606", "33607", "33609", "33610", "33611", "33612", "33613", "33614",
    "33615", "33616", "33617", "33618", "33619", "33620", "33621", "33624", "33625",
    "33626", "33629", "33634", "33635", "33637", "33647",
  ],
  Pasco: [
    "33523", "33525", "33540", "33541", "33542", "33543", "33544", "33545", "33576",
    "34610", "34637", "34638", "34639", "34652", "34653", "34654", "34655", "34667",
    "34668", "34669", "34690", "34691",
  ],
};

const ZIP_TO_COUNTY = new Map<string, string>();
for (const [county, zips] of Object.entries(SERVICE_AREA_ZIPS)) {
  for (const z of zips) ZIP_TO_COUNTY.set(z, county);
}

/** Normaliza a 5 dígitos y devuelve el condado, o null si está fuera de área. */
export function countyForZip(zip: string): string | null {
  const clean = (zip || "").trim().slice(0, 5);
  return ZIP_TO_COUNTY.get(clean) ?? null;
}

export function isInServiceArea(zip: string): boolean {
  return countyForZip(zip) !== null;
}
